var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('services-table',{attrs:{"apiURL":_vm.apiURL,"title":_vm.title,"message":_vm.message,"type":_vm.type,"bus":_vm.bus}})}
var staticRenderFns = []

export { render, staticRenderFns }